export default function applyForm(config = {}) {
  const locale  = document.documentElement.lang || 'ro'
  const baseUrl = locale !== 'ro' ? `/${locale}` : ''

  return {
    idno: '',
    phone: '',
    loading: false,
    error: '',
    success: '',

    async onSubmit() {
      this.loading = true
      this.error = ''
      this.success = ''

      try {
        // const res = await axios.post(`${baseUrl}/product/callback`, {
        //   phone: this.phone,
        // })

        // this.success = res.data.message
        this.phone = this.idno = ''
      } catch (e) {
        if (e.response?.status === 422) {
          this.error = Object.values(e.response.data.errors)[0][0]
        } else {
          this.error = 'Server error'
        }
      } finally {
        this.loading = false
      }
    }
  }
}
